import React, { useContext, useState } from 'react';
import { ModalContext } from '../context/ModalContext';

import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';

function getModalStyle() {
    const top = 50 ;
    const left = 50;
    
    // El modal es scrollable, se agregaron nuevas funciones para eso
    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
      overflowY: "scroll",
      position:'absolute',
      //overflow:'scroll',
      height:'100%',
      display:'block'
    };
}

const useStyles = makeStyles(theme => ({
    paper: {
      position: 'absolute',
      width: 400,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
}));



const Recipe = ({recipe}) => {

    const [ modalStyle ] = useState(getModalStyle);
    const [ open, setOpen ] = useState(false);

    const modalClasses = useStyles();

    const handleOpen = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    }

   const { detail, setRecipeID, setDetail } = useContext(ModalContext);

   const  showIngredients = detail => {
       let ingredients = [];
       for(let i=1; i<= 15; i++){
           if(detail[`strIngredient${i}`]){
               ingredients.push(
                <li> { detail[`strMeasure${i}`] } { detail[`strIngredient${i}`] }</li>
               );
           }
       }
       return ingredients;
   }
   
    return ( 
        <div className="col-md-4 mb-3">
            <div className="card">
                <h2 className="card-header">{ recipe.strDrink }</h2>
                <img className="card-img-top" src={ recipe.strDrinkThumb } alt={`Preview of ${ recipe.strDrink }`}/>
                <div className="card-body">
                    <button
                        type="button"
                        className="btn btn-block btn-primary"
                        onClick={() => {
                            setRecipeID(recipe.idDrink);
                            handleOpen();
                        }}
                    >
                        View Recipe
                    </button>
                    <Modal
                        open={ open }
                        onClose={() => {
                            setRecipeID(null);
                            setDetail({});
                            handleClose();
                        }}
                    >
                        <div style={ modalStyle } className={ modalClasses.paper }>
                            <h2>{ detail.strDrink }</h2>
                            <h3>Ingredints and measures</h3>
                            <ul>
                                { showIngredients(detail) }
                            </ul>
                            <img className="img-fluid my-4" src={ detail.strDrinkThumb } alt={ detail.strDrink }/>
                            <h3 className="mt-4">Instructions</h3>
                            <p className="">
                                { detail.strInstructions }
                            </p>
                            <button
                                className="btn btn-block btn-primary"
                                onClick={ handleClose }
                            >
                                Close
                            </button>
                        </div>
                    </Modal>
                </div>
            </div>
        </div>
     )
}
 
export default Recipe;